module.exports = __webpack_public_path__ + "media/sub7-6-3.6bfb1c92.mp4";